
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as competition_45privacy_45policy_45gwagonNDpl6yyn7zMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-gwagon.vue?macro=true";
import { default as competition_45privacy_45policy_45own_45your_45assetsGguDmW3lMtMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-own-your-assets.vue?macro=true";
import { default as competition_45privacy_45policy_45teslajxTKZqv1oAMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-tesla.vue?macro=true";
import { default as env89ZXjQvZRrMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/env.vue?macro=true";
import { default as fee_45discountsoRKSC4BRaDMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/fee-discounts.vue?macro=true";
import { default as futuresSYLVSMyvKaMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/futures.vue?macro=true";
import { default as _91guild_93x3L2qnEWlGMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/guild/[guild].vue?macro=true";
import { default as guildsTIB14OUWVdMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/guilds.vue?macro=true";
import { default as index3jERB7K952Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/index.vue?macro=true";
import { default as institutionalTfO9495f2IMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/institutional.vue?macro=true";
import { default as competitionIBOMWGHYgeMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/competition.vue?macro=true";
import { default as index1VyJcbEvpWMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/index.vue?macro=true";
import { default as past_45competitionsywWuyhGhe8Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/past-competitions.vue?macro=true";
import { default as leaderboard0CZZqEhIK9Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard.vue?macro=true";
import { default as like_45a_45g_45competition_45termsPnPWz9yruwMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/like-a-g-competition-terms.vue?macro=true";
import { default as locales3qbHYSdyD2Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/locales.vue?macro=true";
import { default as campaignwHpCTUKfOdMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/campaign.vue?macro=true";
import { default as dashboardYkhZzn2JenMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/dashboard.vue?macro=true";
import { default as indexArsJQ3H9tXMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/index.vue?macro=true";
import { default as lp_45rewardspdeO1NKf9UMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards.vue?macro=true";
import { default as maintenanceZYLY30TjjRMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/maintenance.vue?macro=true";
import { default as marketsuJntKpLFYXMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/markets.vue?macro=true";
import { default as mobilevLRnH29HQdMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/mobile.vue?macro=true";
import { default as own_45your_45assets_45competition_45termsJswxIDQXMNMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/own-your-assets-competition-terms.vue?macro=true";
import { default as playgroundFHHjPINNjRMeta } from "/home/runner/_work/injective-helix/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_1IfPyDVKuA/pages/playground.vue?macro=true";
import { default as pointsCBGSSknSYGMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/points.vue?macro=true";
import { default as indexCkCDLhMv81Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/balances/index.vue?macro=true";
import { default as index8xM3Ku6abPMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/funding-history/index.vue?macro=true";
import { default as indexFPhbYA3Ib8Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/swap/index.vue?macro=true";
import { default as indexokky36GjFtMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/wallet/index.vue?macro=true";
import { default as index2XfSLXzXx7Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/index.vue?macro=true";
import { default as futures_45gridnzsQw0yvC2Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures-grid.vue?macro=true";
import { default as advanced_45orders0r8xfmQ2rkMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/advanced-orders.vue?macro=true";
import { default as indexWxb3EpHcs4Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/index.vue?macro=true";
import { default as order_45historyayvB34a10hMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/order-history.vue?macro=true";
import { default as trade_45history0nCmSxVLyJMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/trade-history.vue?macro=true";
import { default as futuresav8G4GPxUKMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures.vue?macro=true";
import { default as spot_45gridNsmAi7V9YeMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot-grid.vue?macro=true";
import { default as indexAEQJ0RbwguMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/index.vue?macro=true";
import { default as order_45history00jY8SKSRHMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/order-history.vue?macro=true";
import { default as trade_45history8Viieyff6AMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/trade-history.vue?macro=true";
import { default as spotG6xmka6BWRMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot.vue?macro=true";
import { default as indexysKpId4cSEMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/positions/index.vue?macro=true";
import { default as granterjKdV9mDfOVMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/granter.vue?macro=true";
import { default as indexJmOzazmRMdMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/index.vue?macro=true";
import { default as authzcN4DYs4aPyMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz.vue?macro=true";
import { default as indexylpx0Ih5SKMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/index.vue?macro=true";
import { default as indexGghfHUPlIkMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/subaccounts/index.vue?macro=true";
import { default as portfolioP31O5NE2kCMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio.vue?macro=true";
import { default as privacy_45policyQUIBL79vYZMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/privacy-policy.vue?macro=true";
import { default as _91ref_93ZtnWh01Q7FMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/ref/[ref].vue?macro=true";
import { default as index8tfESqTAXCMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/ref/index.vue?macro=true";
import { default as spotqbIxxVrw3PMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/spot.vue?macro=true";
import { default as swapSh9WIjupbiMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/swap.vue?macro=true";
import { default as termsIN6WhCGfVFMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/terms.vue?macro=true";
import { default as tesla_45competition_45termskom7fn1vZGMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/tesla-competition-terms.vue?macro=true";
import { default as trade_45and_45earnBFOeVa1EG9Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/trade-and-earn.vue?macro=true";
import { default as indexA7GqjpjHYIMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/index.vue?macro=true";
import { default as indexsnGsAsB6WZMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/liquidity-bots/spot/index.vue?macro=true";
import { default as vaultsJfmoBgoZuRMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/vaults.vue?macro=true";
export default [
  {
    name: "competition-privacy-policy-gwagon",
    path: "/competition-privacy-policy-gwagon",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-gwagon.vue")
  },
  {
    name: "competition-privacy-policy-own-your-assets",
    path: "/competition-privacy-policy-own-your-assets",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-own-your-assets.vue")
  },
  {
    name: "competition-privacy-policy-tesla",
    path: "/competition-privacy-policy-tesla",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-tesla.vue")
  },
  {
    name: "env",
    path: "/env",
    meta: env89ZXjQvZRrMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/env.vue")
  },
  {
    name: "fee-discounts",
    path: "/fee-discounts",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/fee-discounts.vue")
  },
  {
    name: "futures",
    path: "/futures",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "guild-guild",
    path: "/guild/:guild()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/guild/[guild].vue")
  },
  {
    name: "guilds",
    path: "/guilds",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/guilds.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/index.vue")
  },
  {
    name: "institutional",
    path: "/institutional",
    meta: institutionalTfO9495f2IMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/institutional.vue")
  },
  {
    name: leaderboard0CZZqEhIK9Meta?.name,
    path: "/leaderboard",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard.vue"),
    children: [
  {
    name: "leaderboard-competition",
    path: "competition",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/competition.vue")
  },
  {
    name: "leaderboard",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/index.vue")
  },
  {
    name: "leaderboard-past-competitions",
    path: "past-competitions",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/past-competitions.vue")
  }
]
  },
  {
    name: "like-a-g-competition-terms",
    path: "/like-a-g-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/like-a-g-competition-terms.vue")
  },
  {
    name: "locales",
    path: "/locales",
    meta: locales3qbHYSdyD2Meta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/locales.vue")
  },
  {
    name: lp_45rewardspdeO1NKf9UMeta?.name,
    path: "/lp-rewards",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards.vue"),
    children: [
  {
    name: "lp-rewards-campaign",
    path: "campaign",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/campaign.vue")
  },
  {
    name: "lp-rewards-dashboard",
    path: "dashboard",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/dashboard.vue")
  },
  {
    name: "lp-rewards",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/index.vue")
  }
]
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceZYLY30TjjRMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/maintenance.vue")
  },
  {
    name: "markets",
    path: "/markets",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/markets.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: mobilevLRnH29HQdMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/mobile.vue")
  },
  {
    name: "own-your-assets-competition-terms",
    path: "/own-your-assets-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/own-your-assets-competition-terms.vue")
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundFHHjPINNjRMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_1IfPyDVKuA/pages/playground.vue")
  },
  {
    name: "points",
    path: "/points",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/points.vue")
  },
  {
    name: portfolioP31O5NE2kCMeta?.name,
    path: "/portfolio",
    meta: portfolioP31O5NE2kCMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio.vue"),
    children: [
  {
    name: "portfolio-balances",
    path: "balances",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/balances/index.vue")
  },
  {
    name: "portfolio-history-funding-history",
    path: "history/funding-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/funding-history/index.vue")
  },
  {
    name: "portfolio-history-swap",
    path: "history/swap",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/swap/index.vue")
  },
  {
    name: "portfolio-history-wallet",
    path: "history/wallet",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/wallet/index.vue")
  },
  {
    name: "portfolio",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/index.vue")
  },
  {
    name: "portfolio-orders-futures-grid",
    path: "orders/futures-grid",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures-grid.vue")
  },
  {
    name: futuresav8G4GPxUKMeta?.name,
    path: "orders/futures",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures.vue"),
    children: [
  {
    name: "portfolio-orders-futures-advanced-orders",
    path: "advanced-orders",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/advanced-orders.vue")
  },
  {
    name: "portfolio-orders-futures",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/index.vue")
  },
  {
    name: "portfolio-orders-futures-order-history",
    path: "order-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/order-history.vue")
  },
  {
    name: "portfolio-orders-futures-trade-history",
    path: "trade-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/trade-history.vue")
  }
]
  },
  {
    name: "portfolio-orders-spot-grid",
    path: "orders/spot-grid",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot-grid.vue")
  },
  {
    name: spotG6xmka6BWRMeta?.name,
    path: "orders/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot.vue"),
    children: [
  {
    name: "portfolio-orders-spot",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/index.vue")
  },
  {
    name: "portfolio-orders-spot-order-history",
    path: "order-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/order-history.vue")
  },
  {
    name: "portfolio-orders-spot-trade-history",
    path: "trade-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/trade-history.vue")
  }
]
  },
  {
    name: "portfolio-positions",
    path: "positions",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/positions/index.vue")
  },
  {
    name: authzcN4DYs4aPyMeta?.name,
    path: "settings/authz",
    meta: authzcN4DYs4aPyMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz.vue"),
    children: [
  {
    name: "portfolio-settings-authz-granter",
    path: "granter",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/granter.vue")
  },
  {
    name: "portfolio-settings-authz",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/index.vue")
  }
]
  },
  {
    name: "portfolio-settings",
    path: "settings",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/index.vue")
  },
  {
    name: "portfolio-subaccounts",
    path: "subaccounts",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/subaccounts/index.vue")
  }
]
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/privacy-policy.vue")
  },
  {
    name: "ref-ref",
    path: "/ref/:ref()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/ref/[ref].vue")
  },
  {
    name: "ref",
    path: "/ref",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/ref/index.vue")
  },
  {
    name: "spot",
    path: "/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/spot.vue")
  },
  {
    name: "swap",
    path: "/swap",
    meta: swapSh9WIjupbiMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/swap.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/terms.vue")
  },
  {
    name: "tesla-competition-terms",
    path: "/tesla-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/tesla-competition-terms.vue")
  },
  {
    name: "trade-and-earn",
    path: "/trade-and-earn",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trade-and-earn.vue")
  },
  {
    name: "trading-bots",
    path: "/trading-bots",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/index.vue")
  },
  {
    name: "trading-bots-liquidity-bots-spot",
    path: "/trading-bots/liquidity-bots/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/liquidity-bots/spot/index.vue")
  },
  {
    name: "vaults",
    path: "/vaults",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/vaults.vue")
  },
  {
    name: "stocks",
    path: "/futures/stocks",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "futures-slug",
    path: "/futures/:slug()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "spot-slug",
    path: "/spot/:slug()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/spot.vue")
  }
]